export default __webpack_public_path__ + "static/article1-ee0ca8d4e2d53f37923d241bf10d22ea.jpg";